import React from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

import QIllustrationInternal from './QIllustrationInternal';
import type { QIllustrationProps } from './QIllustrationInternal';

export type { IllustrationSize } from './QIllustrationInternal';

export const QIllustration = (props: QIllustrationProps) => (
  <ErrorBoundary size='xs' feedbackSubject={`QIllustration failed to load: ${props.name}`}>
    <QIllustrationInternal {...props}></QIllustrationInternal>
  </ErrorBoundary>
);
export default QIllustration;
